import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"

export const salesPricesRestrictedMarketplaces: MarketplaceKey[] = ["at"]
